import './ScheduleStatus.css';

/** Schedule status labels (the server sends schedule_status). */
export const SCHEDULE_STATUS_LABEL = {
  not_started: 'Not Started Yet',
  in_progress: 'In-Progress',
  closed: 'Closed',
};

/**
 * not_started | in_progress | closed. Uses the server's value; falls back
 * to the audit's times for data loaded before the server sent it.
 */
export function scheduleStatusOf(audit) {
  if (!audit) return null;
  if (audit.schedule_status) return audit.schedule_status;
  const now = Date.now();
  const start = Date.parse(audit.start_at);
  const end = Date.parse(audit.end_at);
  if (Number.isFinite(start) && now < start) return 'not_started';
  if (Number.isFinite(end) && now > end) return 'closed';
  return 'in_progress';
}

/** A closed schedule (end time passed) can no longer be edited. */
export function isScheduleClosed(audit) {
  return scheduleStatusOf(audit) === 'closed';
}

/** Coloured status pill: Closed / In-Progress / Not Started Yet. */
function ScheduleStatus({ audit, status }) {
  const key = status || scheduleStatusOf(audit);
  if (!key) return null;
  return (
    <span className={`schedule-status schedule-status--${key}`}>
      {SCHEDULE_STATUS_LABEL[key] || key}
    </span>
  );
}

/** "2026-10-PT-001" with the status pill next to it. */
export function ScheduleNumber({ audit, withStatus = true }) {
  if (!audit) return null;
  return (
    <span className="schedule-number">
      <span className="schedule-number__no">{audit.schedule_no || 'No schedule number'}</span>
      {withStatus ? <ScheduleStatus audit={audit} /> : null}
    </span>
  );
}

export default ScheduleStatus;
